// extracted by mini-css-extract-plugin
export var askAiIcon = "_n7-9";
export var container = "_n7-0";
export var groupSeparator = "_n7-a";
export var highlight = "_n7-4";
export var resultIcon = "_n7-5";
export var resultItem = "_n7-7";
export var resultSubtitle = "_n7-3";
export var resultTitle = "_n7-2";
export var resultsList = "_n7-1";
export var searchGroup = "_n7-6";
export var selected = "_n7-8";